import axios from "../../utils/axios";

export const fetchToUpdateJob = async (data) => {
    const response = await axios.put(`/jobs/${data.id}`, data);
    return response.data
}
export const fetchSingleJob = async (id) => {
    const response = await axios.get(`/jobs/${id}`);
    return response.data
}